import type { Table } from '@tanstack/react-table';
import { Pagination } from '@/components/Pagination';
import { defaultNS, useTranslation } from '@/lib/i18n';
interface DataTablePaginationProps<TData> {
  table: Table<TData>;
  pageOptions?: number[];
  /** 件数を表示したい場合に渡す。渡すと「○○ 行」と表示される */
  totalCount?: number;
}
export function DataTablePagination<TData>({
  table,
  pageOptions = [100, 200, 300, 400, 500],
  totalCount
}: DataTablePaginationProps<TData>) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.dataTable.pagination'
  });
  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;
  const pageCount = table.getPageCount();
  return <Pagination totalItems={totalCount} pageSize={pageSize} currentPage={pageIndex + 1} maxPage={pageCount} onPageChange={page => table.setPageIndex(page - 1)} onPageSizeChange={size => table.setPageSize(size)} pageSizeOptions={pageOptions} labelOverrides={{
    totalCount: t('rows', {
      count: totalCount
    }),
    perPage: t('rowsPerPage')
  }} />;
}